(function () {
  'use strict';

  var EU_COUNTRIES = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE'];
  var visitorKey = 'cp_nsd_2026_popup_seen';

  function safeJson(value) { try { return JSON.parse(value || '{}'); } catch (error) { return {}; } }
  function marketData(code) {
    if (code === 'US') return { zone: 'America/Los_Angeles', start: '202610080000' };
    if (code === 'GB') return { zone: 'Europe/London' };
    if (EU_COUNTRIES.indexOf(code) !== -1) return { zone: 'Europe/Paris' };
    return null;
  }
  function localStamp(zone) {
    var parts = new Intl.DateTimeFormat('en-CA', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
    var values = {};
    parts.forEach(function (part) { values[part.type] = part.value; });
    return values.year + values.month + values.day + values.hour + values.minute;
  }
  function previewPhase() {
    var preview = new URLSearchParams(window.location.search).get('nsd_preview');
    return ['pre', 'day', 'after'].indexOf(preview) !== -1 ? preview : '';
  }
  function campaignPhase(market) {
    var preview = previewPhase();
    if (preview) return preview;
    var stamp = localStamp(market.zone);
    var start = market.start || '202610080000';
    if (stamp >= start && stamp < '202610100000') return 'day';
    return stamp < start ? 'pre' : 'after';
  }

  function setupBanners() {
    document.querySelectorAll('[data-cp-nsd-banner]').forEach(function (banner) {
      var config = safeJson(banner.getAttribute('data-cp-nsd-settings'));
      var market = marketData(String(config.market || '').toUpperCase());
      if (!config.enabled || !market || campaignPhase(market) !== 'day') return;
      var campaign = banner.querySelector('[data-cp-nsd-campaign-slides]');
      if (!campaign) return;
      var normal = Array.prototype.slice.call(banner.children).filter(function (child) { return child !== campaign; });
      var normalMessages = [];
      normal.forEach(function (node) {
        var items = node.querySelectorAll('.t4s-top-bar-text__item');
        if (!items.length) items = [node];
        Array.prototype.forEach.call(items, function (item) {
          var message = (item.textContent || '').trim();
          if (message && normalMessages.indexOf(message) === -1) normalMessages.push(message);
        });
      });
      /* Only take over a top-bar block that already carries a message (e.g. free shipping); leave empty blocks alone. */
      if (!normalMessages.length) return;
      var promoSlide = document.createElement('p');
      var promoLink = document.createElement('a');
      promoSlide.className = 'cp-nsd-service-banner__slide cp-nsd-service-banner__slide--laces';
      promoLink.href = config.shopUrl || '/collections/all';
      promoLink.textContent = String(config.dayMessage || '');
      promoSlide.appendChild(promoLink);
      campaign.appendChild(promoSlide);
      normal.forEach(function (node) { node.hidden = true; });
      campaign.hidden = false;
      var campaignSlides = [promoSlide];
      normalMessages.reverse().forEach(function (normalText) {
        var normalSlide = document.createElement('p');
        normalSlide.className = 'cp-nsd-service-banner__slide';
        normalSlide.textContent = normalText;
        campaign.insertBefore(normalSlide, campaign.firstChild);
        campaignSlides.unshift(normalSlide);
      });
      var index = 0;
      var paused = false;
      function select(next) {
        campaignSlides.forEach(function (slide, slideIndex) {
          var active = slideIndex === next;
          slide.classList.toggle('is-active', active);
          if (slide === promoSlide) {
            slide.classList.remove('is-flashing');
            if (active) {
              void slide.offsetWidth;
              slide.classList.add('is-flashing');
            }
          }
        });
      }
      function setPaused(nextPaused) { paused = nextPaused; }
      banner.addEventListener('mouseenter', function () { setPaused(true); });
      banner.addEventListener('mouseleave', function () { setPaused(false); });
      banner.addEventListener('focusin', function () { setPaused(true); });
      banner.addEventListener('focusout', function (event) {
        if (!banner.contains(event.relatedTarget)) setPaused(false);
      });
      campaign.setAttribute('aria-live', 'polite');
      select(index);
      if (campaignSlides.length > 1) window.setInterval(function () {
        if (paused) return;
        index = (index + 1) % campaignSlides.length;
        select(index);
      }, Number(config.interval) || 5000);
    });
  }

  function setupModal() {
    var modal = document.querySelector('[data-cp-nsd-modal]');
    if (!modal) return;
    var config = safeJson(modal.getAttribute('data-cp-nsd-config'));
    var market = marketData(String(config.market || '').toUpperCase());
    if (!market || /(^|\/)(cart|checkout)(\/|$)/.test(window.location.pathname) || campaignPhase(market) !== 'day' || !config.dayEnabled) return;
    if (!previewPhase()) try { if (window.localStorage.getItem(visitorKey)) return; } catch (error) {}
    var freeLaceSelector = '[data-free-lace-selector]:not([hidden]), #cp-free-lace-selector:not([hidden]), .cp-free-lace-selector:not([hidden])';
    var previousFocus;
    var observer;
    function markSeen() {
      try { window.localStorage.setItem(visitorKey, '1'); } catch (error) {}
    }
    function close() {
      markSeen();
      modal.hidden = true;
      document.body.classList.remove('cp-nsd-modal-open');
      window.CPPromoModalActive = false;
      if (observer) observer.disconnect();
      document.removeEventListener('keydown', onKeydown);
      if (previousFocus && previousFocus.focus) previousFocus.focus({ preventScroll: true });
    }
    function onKeydown(event) {
      if (event.key === 'Escape') { close(); return; }
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(modal.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])')).filter(function (item) { return !item.disabled; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
    function suppressKlaviyo() {
      document.querySelectorAll('.klaviyo-form, [data-testid="klaviyo-form"]').forEach(function (form) { form.setAttribute('hidden', ''); });
    }
    function open() {
      if (document.querySelector(freeLaceSelector) || window.CPFreeLaceSelectorActive) return;
      previousFocus = document.activeElement;
      window.CPPromoModalActive = true;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'cp_nsd_promo_shown', cp_nsd_phase: 'day' });
      modal.hidden = false;
      document.body.classList.add('cp-nsd-modal-open');
      suppressKlaviyo();
      observer = new MutationObserver(suppressKlaviyo);
      observer.observe(document.body, { childList: true, subtree: true });
      document.addEventListener('keydown', onKeydown);
      modal.querySelector('.cp-nsd-modal__close').focus({ preventScroll: true });
      fitHeadlines();
    }
    function fitHeadlines() {
      modal.querySelectorAll('[data-cp-nsd-fit]').forEach(function (line) {
        line.style.fontSize = '';
        var size = parseFloat(window.getComputedStyle(line).fontSize);
        while (line.scrollWidth > line.parentElement.clientWidth * .74074 && size > 18) {
          size -= 1;
          line.style.fontSize = size + 'px';
        }
      });
    }
    modal.querySelectorAll('[data-cp-nsd-close]').forEach(function (control) { control.addEventListener('click', close); });
    var shopLink = modal.querySelector('[data-cp-nsd-shop]');
    if (shopLink) shopLink.addEventListener('click', markSeen);
    document.addEventListener('cp:free-lace-selector:open', close);
    open();
  }

  function init() { setupBanners(); setupModal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
